module.exports = __webpack_public_path__ + "static/img/55.c44c042.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/55.png
// module id = SbIo
// module chunks = 0